import { useState, useCallback } from 'react';
import { Region, TestResults, NetworkTestName } from '../../types';
import { kixieBitrateTestRunner, kixiePreflightTestRunner } from '../Tests/Tests';

export default function useKixieTestRunner() {
  const [isRunning, setIsRunning] = useState(false);
  const [activeTest, setActiveTest] = useState<NetworkTestName>();
  const [results, setResults] = useState<TestResults[]>([]);
  const [activeRegion, setActiveRegion] = useState<Region>();
  const [customIceServers] = useState<RTCIceServer[]>([
    { urls: 'stun:stun.l.google.com:19302?transport=udp' },
    { urls: 'stun:stun1.l.google.com:19302?transport=udp' },
    { urls: 'stun:stun2.l.google.com:19302?transport=udp' },
    { urls: 'stun:stun3.l.google.com:19302?transport=udp' },
    { urls: 'stun:stun4.l.google.com:19302?transport=udp' },
  ]);

  const runTests = useCallback(
    async (getVoiceToken: () => Promise<string>, regions: Region[]) => {
      setIsRunning(true);
      setResults([]);
      const allResults: TestResults[] = [];

      for (const region of regions) {
        const testResults: TestResults = {
          region: region,
          results: {},
          errors: {},
        };

        setActiveRegion(region);
        setActiveTest('Preflight Test');
        console.log('Initiating Preflight Test', testResults);
        try {
          const voiceToken = await getVoiceToken();
          const iceServers: RTCIceServer[] = customIceServers;

          console.log('preflight', iceServers);
          testResults.results.preflight = await kixiePreflightTestRunner(region, voiceToken, iceServers);
        } catch (err) {
          testResults.errors.preflight = err;
        }

        console.log('Preflight Test Complete', `Results: ${testResults.results.preflight}`);

        if (!testResults.errors.preflight) {
          setActiveTest('Bitrate Test');
          console.log('Initiating Bitrate Test');
          try {
            const iceServers: RTCIceServer[] = customIceServers;
            console.log(iceServers);
            testResults.results.bitrate = await kixieBitrateTestRunner(iceServers);
          } catch (err) {
            testResults.errors.bitrate = err;
          }
        }
        console.log('Bitrate Test Complete', `Results: ${testResults.results.bitrate}`);

        setResults((prevResults) => [...prevResults, testResults]);
        allResults.push(testResults);
      }

      setActiveTest(undefined);
      setActiveRegion(undefined);

      return allResults;
    },
    [customIceServers]
  );

  return {
    isRunning,
    activeTest,
    results,
    activeRegion,
    runTests,
  };
}
